/**
 * @file EscalationModal.tsx
 * @module app/modals/EscalationModal
 * @description Renders the EscalationModal modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Modal, Button, Form } from 'react-bootstrap';
import { useState } from 'react';
import { escalationTypesJSON } from '../../utils/staticJSON';
import { CustomSelect } from '../custom/Select/CustomSelect';

const EscalationModal = ({ show, onHide, onSubmit }: { show: boolean, onHide: () => void, onSubmit: (data: any) => void }) => {
  const [escalationType, setEscalationType] = useState('');
  const [reason, seReason] = useState('');
  const [files, setFiles] = useState<File[]>([]);

  const handleSubmit = () => {
    if (!escalationType) return;
    onSubmit({ escalationType, reason, files });
    setEscalationType('');
    seReason('');
    setFiles([]);
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="modal-lg">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fs-18 fw-bolder">Raise Escalation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Escalation Type */}
          <div className="d-flex flex-column align-items-baseline mb-4">
            <Form.Label className="fs-16 fw-500 text-dark me-5">
              Escalation Type
            </Form.Label>
            <div className="min-w-300px">
              <CustomSelect
                placeholder="Select type..."
                isSearchable={false}
                isClearable={true}
                options={escalationTypesJSON}
                value={escalationTypesJSON.find((o) => o.value === escalationType) || null}
                onChange={(opt: any) => setEscalationType(opt ? opt.value : "")}
              />
            </div>
          </div>

          {/* Comments */}
          <div className="d-flex flex-column mb-4">
            <Form.Label className="fs-16 fw-500 text-dark mb-2">Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              className="form-control border-r8px fs-15"
              value={reason}
              onChange={(e) => seReason(e.target.value)}
            />
          </div>
           {/* File Upload */}
          <div className="d-flex flex-column mb-4">
            <Form.Label className="fs-16 fw-500 text-dark mb-2">
              Attach Files
            </Form.Label>
            <Form.Control
              type="file"
              multiple
              className="form-control border-r8px fs-15"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFiles(e.target.files ? Array.from(e.target.files) : [])
              }
            />
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="light" className="uw-btn uw-btn-light fs-16 fw-500" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" className="uw-btn uw-btn-primary fs-16 fw-500" onClick={handleSubmit}>
          Submit Escalation
        </Button>
      </Modal.Footer>
    </Modal>

  );
};

export default EscalationModal;
